<template>
  <v-container fluid class="pa-8">
    <v-row>
      <v-col cols="12">
        <home-current-page></home-current-page>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="6" lg="6">
        <h2 class="title-page">Manual do Usuário</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-flex flex-column align-start">
        <div class="guide-title">Selecione o assunto que deseja visualizar:</div>
        <div class="pt-2">
          <v-btn-toggle v-model="guide" mandatory style="border: 1px solid #95a1ec"
            :class="this.$vuetify.breakpoint.mdAndDown ? 'd-flex flex-column' : 'd-flex'">
            <v-btn value="Reservatórios" color="#95A1EC" class="btn-group flex-grow-1" height="28">
              Reservatórios
            </v-btn>
            <v-btn value="Monitoramento" color="#95A1EC" class="btn-group flex-grow-1" height="28">
              Monitoramento
            </v-btn>
            <v-btn value="Conservação" color="#95A1EC" class="btn-group flex-grow-1" height="28">
              Conservação
            </v-btn>
            <v-btn value="Indicadores" color="#95A1EC" class="btn-group flex-grow-1" height="28">
              Indicadores
            </v-btn>
            <v-btn value="Efluentes" color="#95A1EC" class="btn-group flex-grow-1" height="28">
              Efluentes
            </v-btn>
          </v-btn-toggle>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div v-if="loading" style="height: 60vh;">
          <loading-animation ></loading-animation>
        </div>
        <PDFJSViewer v-if="!loading && guidePDF" :path="guidePDF.url"></PDFJSViewer>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HomeCurrentPage from '@/components/common/HomeCurrentPage.vue'
import PDFJSViewer from '@/components/reports/PDFJSViewer.vue';
import LoadingAnimation from '@/components/common/LoadingAnimation';


export default {
  components: {
    HomeCurrentPage,
    PDFJSViewer,
    LoadingAnimation
  },
  data: () => ({
    guide: 'Reservatórios',
    guidePDF: undefined,
    loading: false
  }),
  watch: {
    guide: {
      immediate: false,
      handler(newVal) {
        if (newVal) {
          switch (newVal) {
            case 'Reservatórios':
              this.fetchGuide('/statics/infohidro/Reservat%c3%b3rios.pdf')
              break
            case 'Monitoramento':
              this.fetchGuide('/statics/infohidro/Monitoramento.pdf')
              break
            case 'Conservação':
              this.fetchGuide('/statics/infohidro/Conservacao.pdf')
              break
            case 'Indicadores':
              this.fetchGuide('/statics/infohidro/Indicadores.pdf')
              break
            case 'Efluentes':
              this.fetchGuide('/statics/infohidro/Efluentes_e_Dados_Estacoes.pdf')
              break
            default:
              break;
          }
        }
      }
    }
  },
  mounted() {
    this.fetchGuide('/statics/infohidro/Reservat%c3%b3rios.pdf')
  },
  methods: {
    fetchGuide(url) {
      this.loading = true
      fetch(url, { responseType: 'arraybuffer' })
        .then(response => response.blob())
        .then(blobData => {
          const pdfUrl = URL.createObjectURL(blobData);
          this.guidePDF = { url: pdfUrl, name: this.guide }
        })
        .catch(error => {
          console.error('Error fetching the PDF:', error);
        }).finally(() => {
          this.loading = false
        });
    }
  }
}
</script>


<style scoped lang="scss">
.guide-title {
  color: #FFF;
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.title-page {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 33px;
}

.subtitle-page {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
}

.btn-group {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  text-transform: none;
  color: #95a1ec;
  border: 1px solid #95a1ec;
}

.guide {
  height: 76vh;
  overflow-y: auto;
}

#style-2::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: transparent;
}

#style-2::-webkit-scrollbar {
  width: 8px;
  background-color: transparent;
}

#style-2::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #D9D9D9;
}

.guide-img {
  width: 100%;
}


::v-deep .theme--dark.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: #95a1ec !important;
}

::v-deep .v-btn-toggle>.v-btn.v-btn--active {
  color: #95a1ec !important;
  opacity: 1;
}

::v-deep .theme--dark.v-btn.v-btn--has-bg {
  background-color: #212a35 !important;
}
</style>